// extracted by mini-css-extract-plugin
export default {"ButtonWithText":"ToolboxButton_ButtonWithText__yZO9L","ButtonIconWrapper":"ToolboxButton_ButtonIconWrapper__1flh8","Tooltip":"ToolboxButton_Tooltip__orsdM"};